import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { Handling } from './views/Handling';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<Handling />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Handling)
	.setHudVisible(true)
	.build();

export default Layout;
